import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function StickyMobileCTA() {
  const {
    currentPrice,
    checkoutLink
  } = useCountdown();
  return;
}